export default "/images/9142edf9af8f97b1f24ad6e5bd730f6e.avif";